
import Vue from 'vue'
import BaseListContainer from '@/containers/base/BaseListContainer.vue'
import ProspectFilter from '@/components/filters/ProspectFilter.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import {isEmptyObject} from '@/helpers'
import {optionsVslim} from '@/config/v-slim-dialog'

const groupeModule = namespace('groupe')

@Component({
  components: {
    PageLayout,
    PageMenuLayout,
    BaseListContainer
  }
})
export default class ProspectList extends Vue {
  @groupeModule.Action('getGroupesAction') getGroupes: any
  @groupeModule.Action('getGroupeByIdAction') getGroupeById: any
  @groupeModule.Action('deleteGroupeAction') deleteGroupe: any
  @groupeModule.Getter('groupesGetter') groupes: any

  rows = [
    {name: 'Nom', key: 'NOM', orderable: false},
    {name: 'Nombre de prospect(s)', key: 'NB_PROSPECT', orderable: false}
  ]

  mounted() {
    this.getGroupes()
  }

  getNbProspects(n) {
    if (n === 0) return 'Aucun'
    else return n
  }

  async deleteHandler(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du groupe ?', optionsVslim)
    if (ok) {
      this.deleteGroupe(id).then(() => {
        this.getGroupes()
      })
    }
  }
}
